import { Component } from '@angular/core';
import { PositiveNegativeRendererComponent } from '@valg-shared/components/table/renderers/positive-negative-renderer/positive-negative-renderer.component';
import { CellRendererComponent } from '@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive';
import { Column } from '@valg-shared/components/table/table/column';
import NumberFormatService from '@valg-shared/services/number-format-service/number-format.service';
import { getValueAt } from '@valg-shared/utils/object-utils';
import { formatNumberWithDotSeparator } from '@valg-shared/utils/string-utils';

@Component({
  selector: 'valg-responsive-compact-renderer',
  templateUrl: './responsive-compact-renderer.component.html'
})

export class ResponsiveCompactRendererComponent extends PositiveNegativeRendererComponent implements CellRendererComponent{
  compactedText = "";
  compactedValue = 0;
  breakpoint: string = "lg";

  constructor(protected override readonly numberFormatService: NumberFormatService){
    super(numberFormatService);
  }

  public override init(data: unknown, column: Column): void {
    this.showColors = this.getShowColor(column);

    this.breakpoint = column.metadata?.responsiveRenderer?.breakpoint ?? "sm";
    this.value = getValueAt(data, column.path);
    if(this.value === null) {
      this.text = column.metadata?.defaultValueIfNull ?? '';
      this.compactedText = this.text;
      this.showColors = false;
    } else if(this.value !== undefined){
      if(this.formatPercentage(column)){
        this.text = this.numberFormatService.formatPercentage(this.value);
      }
      else{
        this.text = formatNumberWithDotSeparator(this.value, this.showColors);
      }
      if(this.showSignRemark(column)) {
        this.text = this.value > 0 ? `+${this.text}` : `${this.text}`;
      }

      this.showColors = this.getShowColor(column);
      this.handleCompactView(column.metadata?.responsiveRenderer?.path, data, column)
    }
  }

  showSignRemark(column: Column): boolean {
    let type = column.metadata?.rendererOptions?.get('showSignRemark');

    return type ? <boolean>type : false;
  }

  private handleCompactView(compactedPath: string | undefined, data: unknown, column: Column){
    if(compactedPath){
      this.compactedValue = getValueAt(data, compactedPath);
      let type = column.metadata?.responsiveRenderer?.type ?? 'string';
      switch (type) {
        case 'percentage':
          this.compactedText = this.compactedValue == undefined ? "" : this.numberFormatService.formatPercentage(this.compactedValue);
          if(this.compactedValue > 0 && this.showColors){
            this.compactedText = '+'+this.compactedText;
          }
          break;
        case 'number':
          this.compactedText = formatNumberWithDotSeparator(this.compactedValue);
          break;
        default:
          this.compactedText = this.compactedValue.toString();
          break;
      }
    }
  }
}
